import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import "./tag.scss";

const Tag = ({ children, variant = null, small = false }) => (
  <div
    className={classNames(
      "tag",
      {
        "tag--small": small,
        [`tag--${variant}`]: variant,
      },
    )}
  >
    <span>
      {children}
    </span>
  </div>
);

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  small: PropTypes.bool,
  variant: PropTypes.oneOf([
    "primary",
    "registration",
    "events",
    "secondary",
    "donation",
    "tertiary",
    "learn-area",
    "learn-topic",
    "faq",
    "light",
    "dark",
  ]),
};

export default Tag;
